import { render } from "./LocationSvg.vue?vue&type=template&id=6066e79a"
import script from "./LocationSvg.vue?vue&type=script&lang=js"
export * from "./LocationSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__